import { getEnvVariable } from "../../../modules/environmentalList"

const AttachmentAdd = {
    "type": "popup",
    "key": "AttachmentAdd",
    "name": "AttachmentAdd",
    anchor: 'right',
    open: false,
    aliases: {
        open: 'addOpen'
    },
    sharedValues: ['open'],
    container: {
        values: { save: false, back: false, fullscreen: false, },
        mapValues: {
            header: [
                { key: 'exitfullscreen', name: 'exitfullscreen' },
                { key: 'fullscreen', name: 'fullscreen' },
            ],
            Attachment: [{ key: 'save', name: 'save' },
            { key: 'exitfullscreen', name: 'exitfullscreen' },
            { key: 'fullscreen', name: 'fullscreen' },]
        },
        //  sharedValues: ['save', 'edit'],
        mapActionsToEffects: {},
        layout: {
            group: [{
                order: 0,
                type: 'div',
                className: 'm-1',
                components: [{
                    name: 'header',
                    type: 'div',
                    className: 'col-12',
                    sub: {
                        type: 'div',
                        className: 'col-12',
                    }
                }],

            },


            {
                order: 1,
                type: 'div',
                className: 'row application-border m-1',
                components: [{
                    name: 'Attachment',
                    type: 'div',
                    className: 'col-12',
                    sub: {
                        type: 'div',
                        className: 'col-12',
                    }
                }],

            },
            ]
        },

        components: {
            header: {
                name: "header",
                type: 'header',
                title: 'Attachment',
                components: [
                    {
                        type: 'breadcrumbs',
                        items: [
                            { "link": "Add Attachments", "materialicon": "attach_file", className: 'eps-breadcrumb-item ', class: 'text-light' },
                        ]
                    }
                ],
                layout: {},
                actions: [
                    {
                        type: 'icon',
                        icon: 'back',
                        name: 'back',
                        hideon: 'back',
                        hidevalue: false,
                        title: 'Back'
                    },
                    {
                        type: 'icon',
                        icon: 'save',
                        name: 'save',
                        color: 'green',
                        hideon: 'save',
                        hidevalue: false,
                        title: 'Save'
                    },
                    {
                        type: 'icon',
                        icon: 'fullscreen',
                        name: 'fullscreen',
                        hidevalue: false,
                        title: 'Full screen'
                    },
                    {
                        type: 'icon',
                        icon: 'exitfullscreen',
                        name: 'exitfullscreen',
                        hideon: 'fullscreen',
                        hidevalue: false,
                        title: 'Exit Full screen'
                    }
                ],


            },
            Attachment: {
                "type": "form",
                "key": "Attachment",
                "name": "Attachment",
                aliases: {
                    save: 'save',
                },
                sharedValues: ['save', 'back', 'exitfullscreen', 'fullscreen'],
                layout: {

                    group: [
                        {
                            order: 0,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'FileName',
                                type: 'div',
                                className: 'col-10 ml-3 mt-2',
                                sub: {
                                    type: 'div',
                                    className: 'col-10 ml-3 mt-2',
                                }
                            }],

                        },
                        {
                            order: 0,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'parentid',
                                type: 'div',
                                className: 'col-1 ',
                                sub: {
                                    type: 'div',
                                    className: 'col-1 ',
                                }
                            },
                            ],
                        },
                        {
                            order: 2,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'Notes',
                                    type: 'div',
                                    className: 'col-10 ',
                                    sub: {
                                        type: 'div',
                                        className: 'col-10 ',
                                    }
                                },
                            ]
                        },
                        // {
                        //     order: 3,
                        //     type: 'div',
                        //     className: 'row',
                        //     components: [
                        //         {
                        //             name: 'PaperDocument',
                        //             type: 'div',
                        //             className: 'col-5 ',
                        //             sub: {
                        //                 type: 'div',
                        //                 className: 'col-5 ',
                        //             }
                        //         },

                        //     ]
                        // },
                        {
                            order: 4,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'FileDetails',
                                    type: 'div',
                                    className: 'col-10 ',
                                    sub: {
                                        type: 'div',
                                        className: 'col-10 ',
                                    }
                                },
                            ]
                        },


                        // {
                        //     order: 5,
                        //     type: 'div',
                        //     className: 'row',
                        //     components: [
                        //         {
                        //             name: 'UploadDocuments',
                        //             type: 'div',
                        //             className: 'col-12',
                        //             sub: {
                        //                 type: 'div',
                        //                 className: 'col-12'
                        //             }
                        //         },
                        //     ]
                        // },
                    ]




                },
                validationMapKeys: [],
                values: {
                    FileName: '',
                    Notes: '',
                    // PaperDocument: '',
                    UploadDocuments: [],
                    FileDetails: [],
                    //Id: '',
                    parentid: ''

                },
                removeValues: [
                    'Id'
                ],
                "components": {
                    parentid: {
                        "type": "label",
                        "key": "parentid",
                        "label": "parentid",
                        "name": "parentid",
                    },
                    FileName: {
                        "type": "textfield",
                        "key": "FileName",
                        "label": "File Name",
                        "name": "FileName",
                        required: true
                    },
                    Notes: {
                        "type": "textfield",
                        "key": "Notes",
                        "label": "Notes",
                        "name": "Notes",
                        multiline: true,
                        rowsMax: 2,
                        //disabled: getEnvVariable("AccessPortal") == "E" ? true : false
                    },
                    // PaperDocument: {
                    //     "type": "checkbox",
                    //     "key": "PaperDocument",
                    //     "label": "Paper Document",
                    //     "name": "PaperDocument",
                    //     extraProps: {
                    //         transformProps: {
                    //             N: false,
                    //             Y: true,
                    //             'true': 'Y',
                    //             'false': 'N'
                    //         },
                    //     }
                    // },
                    // FileDetails: {
                    //    "type": "upload",
                    //     "key": "FileDetails",
                    //     "label": "Uploads",
                    //     "name": "FileDetails",
                    //    // changefieldto: "upload",
                    //     customField: true
                    // },
                    FileDetails: {
                        "type": "upload",
                        "key": "FileDetails",
                        "label": "Upload Documents",
                        "name": "FileDetails",
                        edit: true,
                        IsFilenet: true,
                        customField: true,
                        ismultiple: true,
                        ischildAttachments: true
                        //callRequest: true,
                        // extraProps: {
                        //     color: 'primary',
                        //     variant: "contained",
                        // },
                    },
                    UploadDocuments: {
                        "type": "upload",
                        "key": "UploadDocuments",
                        // "label": "Upload Documents",
                        "name": "UploadDocuments",
                        edit: true,
                        IsFilenet: true,
                        customField: true,
                        ismultiple: true,
                        // ischildAttachments: true
                        //callRequest: true,
                        // extraProps: {
                        //     color: 'primary',
                        //     variant: "contained",
                        // },
                    },
                },
                mapActionsToEffects: {
                    GLOBAL: {
                        rules: [{
                            run:
                            {
                                valid: [
                                    {
                                        type: 'prop',
                                        name: 'parentid',
                                        hasValue: true,
                                        valueType: 'C',
                                        value: '{{Id}}',
                                        isVisible: false
                                    },
                                ]
                            }
                        }]
                    },

                    'onLoad': {
                        init: {
                            rules: [{
                                run:
                                {
                                    valid: [
                                        {
                                            type: 'validations',
                                            "read": [
                                                {
                                                    "url": getEnvVariable('Sidebar') + `/api/ProjectMessages/RulesByName?name=modulemaster.Attachments`,
                                                    type: 'get'
                                                }
                                            ],
                                            transformProps: {
                                                removesubfieldname: 'MPSMODULEMASTER.ATTACHMENTS_'
                                            },
                                        },
                                        {
                                            type: 'prop',
                                            name: 'parentid',
                                            hasValue: true,
                                            valueType: 'C',
                                            value: '{{Id}}',
                                            isVisible: false
                                        },
                                    ]
                                }
                            }]
                        },



                    },
                    // 'onLoad': {
                    //     init: {
                    //         rules: [{
                    //             run:
                    //             {
                    //                 valid: [
                    //                     {
                    //                         type: 'validations',
                    //                         "read": [
                    //                             {
                    //                                 "url": getEnvVariable('Sidebar') + `/api/ProjectMessages/RulesByName?name=modulemaster.Attachments`,
                    //                                 type: 'get'
                    //                             }
                    //                         ],
                    //                         transformProps: {
                    //                             removesubfieldname: 'MPSMODULEMASTER.ATTACHMENTS_'
                    //                         },
                    //                     },
                    //                     // {
                    //                     //     type: 'businessrules',
                    //                     //     "read": [
                    //                     //         {
                    //                     //             url: getEnvVariable('Sidebar') + `/api/BusinessRules/Grid/modulemaster.Attachments`,
                    //                     //             type: 'get',
                    //                     //         }
                    //                     //     ],
                    //                     // },
                    //                     {
                    //                         type: 'prop',
                    //                         name: 'parentid',
                    //                         hasValue: true,
                    //                         valueType: 'C',
                    //                         value: '{{Id}}',
                    //                         isVisible: false
                    //                     },
                    //                     // {
                    //                     //     type: 'prop',
                    //                     //     name: 'UploadDocuments',
                    //                     //    // isVisible: false
                    //                     // },



                    //                 ]
                    //             }
                    //         }]
                    //     },
                    // },

                    'onChange': {
                        // 'PaperDocument': {
                        //     rules: [

                        //         {
                        //             canOverwrite: false,
                        //             check: [
                        //                 {
                        //                     condition: "AND",
                        //                     rules: [
                        //                         { name: "PaperDocument", type: "=", value: "Y", rules: [] },
                        //                     ]
                        //                 }
                        //             ],

                        //             ruleOrder: 0,
                        //             run: {

                        //                 inValid: [
                        //                     { type: "prop", name: "FileDetails", isVisible: true },
                        //                 ],
                        //                 //   type: "uncheck",
                        //                 valid: [
                        //                     { type: "prop", name: "FileDetails", isVisible: false },
                        //                 ],

                        //             },
                        //             uncheck: true
                        //         },

                        //     ],
                        // },
                        // fields: ["PaperDocument"],
                    },
                    'afterSave': {
                        'save': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            // Fallback: if parentid still blank try again (maybe Id now populated)
                                            //{ type: 'prop', name: 'parentid', hasValue: true, value: '{{Id}}', isVisible: false },
                                            {
                                                type: 'save',
                                                "read": [
                                                    {
                                                        "url": getEnvVariable('Admin') + `/api/CompanyFiles/{parentid}/FileUploadFiles`,
                                                        type: 'post',
                                                        "matchProps": [
                                                            {
                                                                name: "parentid",
                                                                key: "parentid",
                                                            }
                                                        ],
                                                    }

                                                ],
                                            },


                                        ]
                                    }
                                }
                            ]
                        },
                    }
                }
            }
        },

    }
}

export default AttachmentAdd
